window.addEventListener('DOMContentLoaded', () => {
	window.hamburger_toggle = function() {
    $('.bg-menu-mobile').removeClass('d-none')
	}

	window.close_menu = function() {
    $('.bg-menu-mobile').addClass('d-none')
	}
});
